import React, { useEffect, useState } from "react";
import {
  HeroSection,
  TopCakes,
  WeddingCakes,
  Contact
} from '../components/HomeComponents/index'
const WEDDING_HASH = "#wedding-cakes";

const Home = () => {
  // Only one of Top Cakes / Wedding Cakes is shown at a time, chosen by the URL hash.
  const [showWedding, setShowWedding] = useState(window.location.hash === WEDDING_HASH);

  useEffect(() => {
    const onHashChange = () => {
      const hash = window.location.hash;
      if (hash === WEDDING_HASH || hash === "#top-orders") {
        setShowWedding(hash === WEDDING_HASH);
      }
    };
    window.addEventListener("hashchange", onHashChange);
    return () => window.removeEventListener("hashchange", onHashChange);
  }, []);

  // The target section only exists after the switch renders, so scroll to it afterwards.
  useEffect(() => {
    const id = window.location.hash.slice(1);
    if (id === "wedding-cakes" || id === "top-orders") {
      document.getElementById(id)?.scrollIntoView();
    }
  }, [showWedding]);

  return (<>
  
  <div>
    <HeroSection/>
    { /*<About/> */ }
    {showWedding ? <WeddingCakes/> : <TopCakes/>}
    { /*<Roadmap/>*/ }
    { /*<Team/>*/ }
    <Contact/>
  </div>
  </>);
};

export default Home;
